<div class="dialog-container p-20">
  <div class="header">
    <mat-icon aria-hidden="true">verified_user</mat-icon>
    <h2>{{ data?.title || 'Finalize DiagnosticReport' }}</h2>
  </div>

  <div class="body">
    <p>
      {{
      data?.message ||
      'To save this DiagnosticReport as FINAL, type your last name to confirm. Final reports are locked from editing.'
      }}
    </p>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Last name</mat-label>
      <input matInput [formControl]="lastNameCtrl" autocomplete="off" />
      <mat-hint>Case-insensitive</mat-hint>
      @if (lastNameCtrl.touched && lastNameCtrl.invalid) {
      <mat-error>Last name is required</mat-error>
      }
    </mat-form-field>

    @if (lastNameCtrl.value && !canConfirm) {
    <div class="mismatch">Last name does not match the logged-in user.</div>
    }
  </div>

  <div class="actions">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="confirm()" [disabled]="!canConfirm">Finalize</button>
  </div>
</div>
